import React from "react";
import useAxios from "axios-hooks";
import FluentSelect from "../../../../Forms/FluentSelect";

const ClientDropdown = ({ setOptionTable, isMulti = true, ...rest }) => {
  const [{ data: clients, loading: loadingClients }] = useAxios(
    "/internal/clients"
  );

  const clientOptions =
    clients &&
    clients.map((client) => ({ value: client.clientID, label: client.name }));

  return (
    <FluentSelect
      options={clientOptions}
      disabled={loadingClients}
      isMulti={isMulti}
      {...rest}
    />
  );
};

export default ClientDropdown;
